// reducers/systems/catalog.js

export function catalogHasErrored(state = false, action) {
  switch (action.type) {
    case 'CATALOG_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function catalogIsLoading(state = false, action) {
  switch (action.type) {
    case 'CATALOG_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function catalog(state = [], action) {
  switch (action.type) {
    case 'CATALOG_FETCH_DATA_SUCCESS':
      return action.response;
    default:
      return state;
  }
}